import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage, IntlProvider, injectIntl } from "react-intl";
import HyperLink from "./HyperLink";
import PropTypes from "prop-types";
import { Button } from "./fields/Button";
import { Hidden } from "@material-ui/core";
import Headset from "@material-ui/icons/Headset";

export class ContactUsLink extends Component {

    /**
     * @return {string}
     */
    getContactUsUrl() {
        return "https://help.fadv.com/";
    }

    render() {
        const bespokeContactUsButtonClassname = "text-md font-normal font-sans bg-transparent border-none px-1.5 py-2 hover:drop-shadow text-primary-fg";
        return (
            <HyperLink
                target="_blank"
                to={this.getContactUsUrl()}
            >
                <Button
                    fullWidth
                    component={HyperLink}
                    id="contactUs"
                    name="contactUs"
                    variant="text"
                    className={bespokeContactUsButtonClassname}
                >
                    <Hidden smUp>
                        <Headset className="text-neutral-600" />
                    </Hidden>
                    <Hidden xsDown>
                        <FormattedMessage id="login.contactUsText" defaultMessage="Contact Us" description="Button for contacting support" />
                    </Hidden>
                </Button>
            </HyperLink>
        )
    }
}

ContactUsLink.propTypes = {
    locale: PropTypes.string,
};
ContactUsLink.propTypes = {
    classes: PropTypes.object.isRequired,
    intl: PropTypes.objectOf(IntlProvider),
    locale: PropTypes.string
};
const mapStateToProps = state => {
    return {
        contactUsUrl: state.loginForm.contactUsUrl,
        locale: state.intl.locale
    }
};
export default connect(mapStateToProps)(injectIntl(ContactUsLink));